//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"
import {} from "shared/search/containers/Filter/Filters"

import {
    RegulationCommentSourceTypeFilter,
    RegulationCommentDateListNoFutureFilter,
    RegulationCommentDatePickerStartNoFutureFilter,
    RegulationCommentDatePickerEndNoFutureFilter,
    RegulationCommentDateReceivedByAgencyNoFutureFilter,
    RegulationCommentDateReceivedByAgencyPickerStartNoFutureFilter,
    RegulationCommentDateReceivedByAgencyPickerEndNoFutureFilter,
    RegulationCommentDatePostedByAgencyNoFutureFilter,
    RegulationCommentDatePostedByAgencyPickerStartNoFutureFilter,
    RegulationCommentDatePostedByAgencyPickerEndNoFutureFilter,
    RegulationCommentDocketSourceFilter,
    RegulationCommentRegulationSourceFilter,
    RegulationCommentRegulationDocumentSourceFilter,
    RegulationCommentTitleFilter,
    RegulationCommentAuthorFilter,
    RegulationCommentOrganizationFilter,
    RegulationCommentCategoryFilter,
    RegulationCommentAnonymousFilter,
    RegulationCommentAttachmentFilter,
    RegulationCommentSourceFilter,
} from "shared/search/containers/Filter/RegulationCommentFilters"

const defaultPropTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const RegulationCommentSourceTypeFilterGroup = (props) => genericFilterGroup(props)
RegulationCommentSourceTypeFilterGroup.propTypes = defaultPropTypes
RegulationCommentSourceTypeFilterGroup.defaultProps = {
    filters: [
        RegulationCommentAnonymousFilter,
        RegulationCommentSourceFilter,
        RegulationCommentAttachmentFilter,
        // commented out because there is currently only one RegCommentSourceType
        // RegulationCommentSourceTypeFilter,
    ],
    uniqueFilterGroupId: "regulationCommentSourceTypeFilterGroup",
    displayLabel: "Comment Type",
    helpText: "Filter by Regulation Comment type.",
}

export const RegulationCommentDateFilterGroup = (props) => genericFilterGroup(props)
RegulationCommentDateFilterGroup.propTypes = defaultPropTypes
RegulationCommentDateFilterGroup.defaultProps = {
    filters: [
        RegulationCommentDateListNoFutureFilter,
        RegulationCommentDatePickerStartNoFutureFilter,
        RegulationCommentDatePickerEndNoFutureFilter,

        RegulationCommentDateReceivedByAgencyNoFutureFilter,
        RegulationCommentDateReceivedByAgencyPickerStartNoFutureFilter,
        RegulationCommentDateReceivedByAgencyPickerEndNoFutureFilter,

        RegulationCommentDatePostedByAgencyNoFutureFilter,
        RegulationCommentDatePostedByAgencyPickerStartNoFutureFilter,
        RegulationCommentDatePostedByAgencyPickerEndNoFutureFilter,
    ],
    uniqueFilterGroupId: "regulationCommentDateFilterGroup",
    displayLabel: "Date",
    helpText: "Filter for Regulation Comments by their various associated dates.",
}

export const RegulationCommentAssociatedFilterGroup = (props) => genericFilterGroup(props)
RegulationCommentAssociatedFilterGroup.propTypes = defaultPropTypes
RegulationCommentAssociatedFilterGroup.defaultProps = {
    filters: [
        RegulationCommentDocketSourceFilter,
        RegulationCommentRegulationSourceFilter,
        RegulationCommentRegulationDocumentSourceFilter,

        RegulationCommentTitleFilter,
        RegulationCommentAuthorFilter,
        RegulationCommentOrganizationFilter,
        RegulationCommentCategoryFilter,
    ],
    uniqueFilterGroupId: "regulationCommentAssociatedFilterGroup",
    displayLabel: "Referencing",
    helpText: "Filter by the data point that the Regulation Comment is referencing.",
}
